import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../../api";
import "../styles/Home.css";
import { FiUsers, FiRefreshCw, FiClock } from "react-icons/fi";
import illustration from "../../../images/students-home.png"; // Adjust path as needed

export default function Home() {
  const nav = useNavigate();
  const [stats, setStats] = useState(null);
  const [countdown, setCountdown] = useState("Loading...");

  useEffect(() => {
    apiGet("/stats")
      .then(setStats)
      .catch((err) => {
        console.error("Failed to fetch stats:", err);
        setStats({ userCount: "N/A", lastRefresh: null });
      });
  }, []);

  useEffect(() => {
    if (!stats?.lastRefresh) return;

    const last = new Date(stats.lastRefresh + " 00:00:00");
    const next = new Date(last);
    next.setDate(last.getDate() + 90);

    const interval = setInterval(() => {
      const diff = next - new Date();
      if (diff <= 0) {
        setCountdown("Date TBD.");
        clearInterval(interval);
        return;
      }
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      setCountdown(`${d}d ${h}h ${m}m`);
    }, 1000);

    return () => clearInterval(interval);
  }, [stats]);

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section page-card">
        <div className="hero-text">
          <h1>Connect & Conquer Your Courses!</h1>
          <p>See your classmates' schedules, make friends, and ace your classes together.</p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => nav("/app/react/select-courses")}>
              1. Select Courses
            </button>
            <button className="btn btn-secondary" onClick={() => nav("/app/react/find-classmates")}>
              2. Find Classmates
            </button>
          </div>
        </div>
        <div className="hero-illustration">
          <img src={illustration} alt="Friendly student illustration" />
        </div>
      </div>

      {/* Dashboard Cards */}
      <div className="dashboard-cards">
        <div className="info-card page-card">
          <FiUsers className="card-icon" />
          <h3>Total Users</h3>
          <p>{stats?.userCount ?? "..."}</p>
        </div>
        <div className="info-card page-card">
          <FiRefreshCw className="card-icon" />
          <h3>Next Data Refresh</h3>
          <p>{countdown}</p>
        </div>
        <div className="info-card page-card">
          <FiClock className="card-icon" />
          <h3>Last Refresh</h3>
          <p>{stats?.lastRefresh ?? "..."}</p>
        </div>
      </div>

      {/* How it Works Section */}
      <div className="how-it-works-section page-card">
        <h2>How it Works</h2>
        <div className="video-responsive">
          <iframe
            width="853"
            height="480"
            src="https://www.youtube.com/embed/tVtsIS7bOR0"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="How the App Works"
          ></iframe>
        </div>
      </div>
    </div>
  );
}